import React, { useState } from "react";
import axios from "axios";

export default function Register() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    role: "employee"
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const register = async () => {
    // 🔍 Basic validation
    if (!form.name || !form.email || !form.mobile || !form.password) {
      alert("Please fill all fields");
      return;
    }

    if (!/^[0-9]{10}$/.test(form.mobile)) {
      alert("Enter valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        "https://gantasoft.in/cab-g/dev/driver/v1/admin_register.php",
        form
      );

      if (res.data.success) {
        alert("Registration Successful ✅");
        setForm({
          name: "",
          email: "",
          mobile: "",
          password: "",
          role: "employee"
        });
      } else {
        alert(res.data.message || "Registration failed");
      }

    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
        
        <h2 className="text-2xl font-bold mb-4 text-center">
          Register
        </h2>

        {/* Name */}
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          className="w-full mb-3 p-2 border rounded"
        />

        {/* Email */}
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          className="w-full mb-3 p-2 border rounded"
        />

        {/* Mobile */}
        <input
          type="text"
          name="mobile"
          placeholder="Mobile Number"
          value={form.mobile}
          onChange={handleChange}
          className="w-full mb-3 p-2 border rounded"
        />

        {/* Password */}
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          className="w-full mb-3 p-2 border rounded"
        />

        {/* Role */}
        <select
          name="role"
          value={form.role}
          onChange={handleChange}
          className="w-full mb-4 p-2 border rounded"
        >
          <option value="employee">Employee</option>
          <option value="admin">Admin</option>
        </select>

        {/* Button */}
        <button
          onClick={register}
          disabled={loading}
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
        >
          {loading ? "Registering..." : "Register"}
        </button>

      </div>
    </div>
  );
}